// globalFuncWS.js
import { EventBus } from './eventBus'

export default {
  install (Vue) {
    Vue.prototype.connectWebSocketWS = function () {
      if (this.GLOBAL.socket && this.GLOBAL.socket.readyState === WebSocket.OPEN) {
        console.log('Closing old ws connection to avoid data conflict')
        this.closeWebSocket()
      }

      const token = this.generateJwtToken()
      const wsUrl = this.GLOBAL.SOCKET_URL_WS + '?t=' + Date.now()
      this.GLOBAL.socketws = new WebSocket(wsUrl, [token])

      this.GLOBAL.socketws.addEventListener('open', (event) => {
        console.log('WebSocket connection is open', event)
      })

      this.GLOBAL.socketws.addEventListener('message', (event) => {
        const receivedData = JSON.parse(event.data)
        this.$set(this.GLOBAL, 'datews', receivedData.date)
        this.$set(this.GLOBAL, 'tableListws', receivedData.priceData)
        EventBus.$emit('dateUpdated', this.GLOBAL.datews)
        EventBus.$emit('tabListUpdated', this.GLOBAL.tableListws)
      })

      // 保存 close 事件处理器的引用，以便后续移除
      const closeHandlerWS = (event) => {
        console.log('WebSocket connection is closed', event)
        // WebSocket 断开时保留上一秒的数据，不清空
        // datews 和 tableListws 保持不变，继续显示缓存的数据
        this.startReconnectIntervalWS()
      }
      this.GLOBAL.socketws._closeHandlerWS = closeHandlerWS
      this.GLOBAL.socketws.addEventListener('close', closeHandlerWS)

      this.GLOBAL.socketws.addEventListener('error', (event) => {
        console.error('WebSocket error:', event)
      })
    }
    Vue.prototype.reconnectWebSocketWS = function () {
      if (!this.GLOBAL.socketws || this.GLOBAL.socketws.readyState !== WebSocket.OPEN) {
        console.log('Reconnecting WebSocket...')
        this.connectWebSocketWS()
      }
    }
    Vue.prototype.startReconnectIntervalWS = function () {
      clearInterval(this.GLOBAL.reconnectIntervalws)
      this.GLOBAL.reconnectIntervalws = setInterval(() => {
        this.reconnectWebSocketWS()
      }, 5000)
    }
    Vue.prototype.closeWebSocketWS = function () {
      clearInterval(this.GLOBAL.reconnectIntervalws)
      if (this.GLOBAL.socketws) {
        if (this.GLOBAL.socketws._closeHandlerWS) {
          this.GLOBAL.socketws.removeEventListener('close', this.GLOBAL.socketws._closeHandlerWS)
          delete this.GLOBAL.socketws._closeHandlerWS
        }
        if (this.GLOBAL.socketws.readyState === WebSocket.OPEN || this.GLOBAL.socketws.readyState === WebSocket.CONNECTING) {
          this.GLOBAL.socketws.close()
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/globalFuncWS.js